import { MOBILE_NAVIGATION_ENUMS } from "constants/navigation/mobileNavigation";
import {
  FormatNotificationSidebarProfileParams,
  FormatNotificationTabBarMobileParams,
  FormatNotificationSidebarMobileParams,
} from "types/notificationNavigation";
import { PROFILE_NAVIGATION_ENUMS } from "./navigation/profile";
import { TABBAR_NAVIGATION_ENUM } from "./navigation/tabbar";

export const mapKeysSidebar: Record<
  keyof FormatNotificationSidebarProfileParams,
  PROFILE_NAVIGATION_ENUMS
> = {
  account: PROFILE_NAVIGATION_ENUMS.ACCOUNT,
  historyTransactions: PROFILE_NAVIGATION_ENUMS.TRANSACTIONS,
  historyGames: PROFILE_NAVIGATION_ENUMS.GAMES_HISTORY,
  myBonuses: PROFILE_NAVIGATION_ENUMS.BONUS,
  support: PROFILE_NAVIGATION_ENUMS.SUPPORT,
};

export const mapKeysTabBarMobile: Record<
  keyof FormatNotificationTabBarMobileParams,
  TABBAR_NAVIGATION_ENUM
> = {
  menu: TABBAR_NAVIGATION_ENUM.MENU,
  casino: TABBAR_NAVIGATION_ENUM.CASINO,
  deposit: TABBAR_NAVIGATION_ENUM.DEPOSIT,
  // tournaments: TABBAR_NAVIGATION_ENUM.TOURNAMENT,
  favorites: TABBAR_NAVIGATION_ENUM.SUPPORT,
};

export const mapKeysSidebarMobile: Record<
  keyof FormatNotificationSidebarMobileParams,
  MOBILE_NAVIGATION_ENUMS
> = {
  home: MOBILE_NAVIGATION_ENUMS.HOME,
  welcomeBonus: MOBILE_NAVIGATION_ENUMS.WELCOME_BONUS,
  support: MOBILE_NAVIGATION_ENUMS.SUPPORT,
  tournaments: MOBILE_NAVIGATION_ENUMS.TOURNAMEMTNS,
  aviator: MOBILE_NAVIGATION_ENUMS.AVIATOR,
  jackpot: MOBILE_NAVIGATION_ENUMS.JACKPOT,
  profile: MOBILE_NAVIGATION_ENUMS.PROFILE,
  transactionsHistory: MOBILE_NAVIGATION_ENUMS.TRANSACTIONS_HISTORY,
  gamesHistory: MOBILE_NAVIGATION_ENUMS.GAMES_HISTORY,
  myBonus: MOBILE_NAVIGATION_ENUMS.MY_BONUS,
  accessRecovery: MOBILE_NAVIGATION_ENUMS.ACCESS_RECOVERY,
};
